import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { LoginResultDto } from '../data-models/identity.data.models';
import { SignalrService } from 'src/app/shared/services/signalr.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private _currentUserCredantials?: LoginResultDto;
  private userCredentialsSubject: BehaviorSubject<LoginResultDto | undefined> =
    new BehaviorSubject<LoginResultDto | undefined>(
      localStorage.getItem('currentUser')
        ? JSON.parse(localStorage.getItem('currentUser') as string)
        : undefined,
    );
  public currentUserCredantials$: Observable<LoginResultDto | undefined> =
    this.userCredentialsSubject.asObservable();

  constructor(
    private router: Router,
    private signalrService: SignalrService,
  ) {}

  getCurrentSystemLanguage(): string {
    let language = localStorage.getItem('language');
    if (language) return language;
    else {
      localStorage.setItem('language', 'en-US');
      return 'en-US';
    }
  }
  setLanguage(language: string) {
    localStorage.setItem('language', language);
  }

  get currentUserCredantials(): LoginResultDto {
    if (localStorage.getItem('currentUser')) {
      return JSON.parse(
        localStorage.getItem('currentUser') as string,
      ) as LoginResultDto;
    } else return undefined!;
  }
  set currentUserCredantials(value: LoginResultDto | undefined) {
    if (value && value.expiryTokenInMinutes) {
      var expiryDate = new Date();
      expiryDate.setMinutes(
        expiryDate.getMinutes() + value.expiryTokenInMinutes! - 5,
      );
      value.expiryTokenDate = expiryDate;
    }
    this._currentUserCredantials =
      value == undefined ? value : JSON.parse(JSON.stringify(value));
    localStorage.setItem(
      'currentUser',
      this._currentUserCredantials
        ? JSON.stringify(this._currentUserCredantials)
        : '',
    );
    this.userCredentialsSubject.next(this._currentUserCredantials);
  }

  updateUserKYCStatus(status: string) {
    const creds = this.currentUserCredantials;
    if (creds && creds.userKYCStatus !== status) {
      this.currentUserCredantials = {
        ...creds,
        userKYCStatus: status,
      };
    }
  }

  isLoggedIn(): boolean {
    if (this.currentUserCredantials) return true;
    else return false;
  }

  logout() {
    this.clearLocalStorage();
    try {
      this.signalrService?.stopConnection();
    } catch (e) {
      console.error('Error stopping SignalR connection on logout:', e);
    }
    this.router
      .navigate(['/authentication/login'])
      .then((navigated) => {
        if (navigated) {
          window.location.reload();
        } else {
          window.location.href = '/authentication/login';
        }
      })
      .catch((err) => {
        console.error('Navigation to login failed on logout:', err);
        window.location.href = '/authentication/login';
      });
  }
  clearLocalStorage() {
    this._currentUserCredantials = undefined;
    localStorage.removeItem('currentUser');
    localStorage.removeItem('investTypeId');
    localStorage.removeItem('requestId');
    this.userCredentialsSubject.next(undefined);
  }
}
